<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 isis-modal-header">
      <span :class="statusClass" class="mx-0 mb-2">{{
        progressReport.report_status
      }}</span>
    </div>

    <div class="md-layout-item md-size-33 md-small-size-100">
      {{ $t("common.term") }}:
      <span class="font-medium">
        {{ progressReport.term && progressReport.term.name }}
      </span>
    </div>

    <div class="md-layout-item md-size-33 md-small-size-100">
      {{ $t("submitted_report.report_type") }}:
      <span class="font-medium">
        {{ $t(`submitted_report.${progressReport.report_type}`) }}
      </span>
    </div>

    <IgsusHighSchoolReport
      v-if="isHighSchool"
      :form-props="progressReport"
      reportTemplate="high_school"
      :isViewOnly="true"
      :embedded="true"
      :canToggleAttendance="mode === 'reviewer'"
      ref="templateReviewReport"
    />
    <TemplateProgressReport
      v-else
      :form-props="progressReport"
      :reportTemplate="progressReport.report_template"
      :isViewOnly="!canEdit"
      :isDisable="isDisable"
      :term-id="progressReport.term_id"
      :generateVietnamese="generateVietnamese"
      ref="templateReviewReport"
    />

    <div class="md-layout-item md-size-100 mt-6 font-medium">
      {{ $t("submitted_report.reviewer_verification") }}
    </div>
    <div class="md-layout-item md-size-100 mt-3">
      <label> {{ $t("submitted_report.reason_for_refusal") }}</label>
      <div class="border border-gray-300 p-2">
        <md-field>
          <md-textarea
            v-model="reviewerVerification"
            :disabled="mode !== 'reviewer'"
            class="p-0"
          ></md-textarea>
        </md-field>
      </div>
    </div>

    <div class="md-layout-item md-size-100 mt-4 text-right">
      <md-button
        v-if="
          mode === 'inputter' && progressReport.status === status.not_approve
        "
        class="md-warning mr-4"
        @click="updateProgressReport(status.pending)"
        >{{ $t("submitted_report.send_and_review_again") }}
      </md-button>

      <md-button class="md-raised mr-4" @click="closeModal"
        >{{ $t("common.cancel") }}
      </md-button>

      <md-button
        v-if="mode === 'reviewer'"
        :class="reviewerVerification ? 'md-warning' : 'md-raised'"
        :disabled="!reviewerVerification"
        class="mr-4"
        @click="updateProgressReport(status.not_approve)"
        >{{ $t("submitted_report.reject") }}
      </md-button>

      <md-button
        v-if="mode === 'reviewer'"
        class="md-success"
        @click="updateProgressReport(status.official)"
        >{{ $t("submitted_report.approve") }}
      </md-button>
    </div>
  </div>
</template>
<script>
import { service_names, service_paths } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import { convertDateFromServer } from "@/helpers/datetime-helper";
import TemplateProgressReport from "../Components/Templates";
import IgsusHighSchoolReport from "../Components/TemplateReportForProgress/IgsusHighSchoolReport";

export default {
  props: [
    "modalName",
    "mode",
    "progress",
    "reportType",
    "generateVietnamese",
    "isDisable"
  ],
  components: { TemplateProgressReport, IgsusHighSchoolReport },
  data() {
    return {
      convertDateFromServer,
      status: {
        pending: "Pending",
        not_approve: "Not-approve",
        official: "Official"
      },
      progressReport: this.progress,
      reviewerVerification: this.progress.reviewer_verification
    };
  },
  computed: {
    isHighSchool() {
      return this.reportType === "high_school";
    },
    // high_school is stored by the standard endpoint and exported by the shared one
    apiTemplate() {
      return this.isHighSchool ? "standard" : this.reportType;
    },
    apiExportTemplate() {
      return this.isHighSchool ? "progress" : this.reportType;
    },
    canEdit() {
      return (
        (this.mode === "inputter" &&
          this.progressReport.status === this.status.not_approve) ||
        this.mode === "reviewer"
      );
    },
    statusClass() {
      if (this.progressReport.status === this.status.not_approve) {
        return "rejected-status";
      }
      return "pending-status";
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide(this.modalName);
      this.$emit("reloadData");
    },

    updateProgressReport(progressStatus) {
      let form = this.$refs.templateReviewReport.buildFormSave(
        "not_validate_all"
      );
      form.reviewer_verification = this.reviewerVerification;

      this.$axios
        .patch(
          `${service_names.user}/progress-${this.apiTemplate}/${getId(
            this.progressReport
          )}`,
          { ...form, status: progressStatus }
        )
        .then(() => {
          this.$modal.hide(this.modalName);
          this.$emit("reloadData");
          if (progressStatus === this.status.official) {
            Message.success(this.$t("submitted_report.approve_success"));
            this.$axios.post(
              `${service_paths.export}/multiple/${this.apiExportTemplate}-report`,
              { array_progress_id: [getId(this.progressReport)] }
            );
          } else {
            Message.success(this.$t("common.update_success"));
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.isis-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;

  .rejected-status {
    margin: 0 12px;
    background: #ffccc8;
    border-radius: 4px;
    color: #f44336;
    padding: 6px 12px;
    font-weight: 500;
  }

  .pending-status {
    margin: 0 12px;
    background: #ffe9b9;
    border-radius: 4px;
    color: #d36f1a;
    padding: 6px 12px;
    font-weight: 500;
  }
}
</style>
